import { createContext, useContext, type ReactNode } from 'react'

export type BuilderStepDirection = 'forward' | 'back'

export type ListingBuilderContextValue = {
  enabled: boolean
  step: number
  /** Set when navigating between steps (Continue / Back / stepper). */
  stepDirection: BuilderStepDirection | null
}

export const ListingBuilderContext = createContext<ListingBuilderContextValue>({
  enabled: false,
  step: 1,
  stepDirection: null,
})

export function useListingBuilder(): ListingBuilderContextValue {
  return useContext(ListingBuilderContext)
}

/** When desktop builder is on, render children only on the matching step. */
export function BuilderStepGate({ step, children }: { step: number; children: ReactNode }) {
  const { enabled, step: activeStep } = useListingBuilder()
  if (!enabled) return <>{children}</>
  if (activeStep !== step) return null
  return <>{children}</>
}
